module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro Histori Pembatalan ")]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.giroDateSelected),
      callback: function($$v) {
        _vm.giroDateSelected = $$v
      },
      expression: "giroDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.paymentDateSelected),
      callback: function($$v) {
        _vm.paymentDateSelected = $$v
      },
      expression: "paymentDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.markingHeaderIdSelected),
      callback: function($$v) {
        _vm.markingHeaderIdSelected = $$v
      },
      expression: "markingHeaderIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingGiroList),
      expression: "isLoadingGiroList"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v(" Total Giro = " + _vm._s(_vm.totalGiro) + " lembar")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(" Total Nominal = Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalNominal)))]), _vm._v(" "), _c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "columns": _vm.columnsDataTable,
      "data": _vm.receivableGiroData
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.isModalAddGiro),
      callback: function($$v) {
        _vm.isModalAddGiro = $$v
      },
      expression: "isModalAddGiro"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Giro")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAddGiro",
    attrs: {
      "model": _vm.formAddGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Form-item', [_c('Row', [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupAdd),
      callback: function($$v) {
        _vm.isGroupAdd = $$v
      },
      expression: "isGroupAdd"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11",
      "offset": "1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-up"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupAdd == false),
      expression: "isGroupAdd == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        _vm.isForm = true
      }
    },
    model: {
      value: (_vm.formAddGiro.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingHeaderId", $$v)
      },
      expression: "formAddGiro.markingHeaderId"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-down"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupAdd == true),
      expression: "isGroupAdd == true"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        _vm.isForm = true
      }
    },
    model: {
      value: (_vm.formAddGiro.markingGroupId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingGroupId", $$v)
      },
      expression: "formAddGiro.markingGroupId"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForm),
      expression: "isForm"
    }]
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal Terima Giro",
      "prop": "giroDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Terima Giro",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formAddGiro.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroDate", $$v)
      },
      expression: "formAddGiro.giroDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor Giro",
      "prop": "giroNumber"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Nomor Giro"
    },
    model: {
      value: (_vm.formAddGiro.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroNumber", $$v)
      },
      expression: "formAddGiro.giroNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nominal Giro",
      "prop": "giroNominal"
    }
  }, [_c('br'), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input",
    model: {
      value: (_vm.formAddGiro.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroNominal", $$v)
      },
      expression: "formAddGiro.giroNominal"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "paymentDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Jatuh Tempo",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formAddGiro.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "paymentDate", $$v)
      },
      expression: "formAddGiro.paymentDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.formAddGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "bankAccountId", $$v)
      },
      expression: "formAddGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                        ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Upload File",
      "prop": "file"
    }
  }, [_c('br'), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAddGiro.markingHeaderCode),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingHeaderCode", $$v)
      },
      expression: "formAddGiro.markingHeaderCode"
    }
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgress),
      expression: "isProgress"
    }],
    attrs: {
      "percent": _vm.pValue,
      "stroke-width": 20
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingAddGiro
    },
    on: {
      "click": _vm.postAddGiro
    }
  }, [(!_vm.isLoadingAddGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi"
    },
    on: {
      "on-cancel": _vm.cancelUpdateGiroList
    },
    model: {
      value: (_vm.isModalConfirm),
      callback: function($$v) {
        _vm.isModalConfirm = $$v
      },
      expression: "isModalConfirm"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.confirmationMessage))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedConfirm),
      expression: "isNeedConfirm"
    }]
  }, [_c('i', [_vm._v(" Tambah keterangan untuk melanjutkan ! (minimal 5 karakter)")]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "notes"
    },
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], 1), _vm._v(" "), (_vm.isNeedConfirm) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmDescription.length >= 5),
      expression: "confirmDescription.length >= 5"
    }],
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.updateGiroList
    }
  }, [_vm._v("Ya")])], 1) : _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.cancelUpdateGiroList
    }
  }, [_vm._v("Tidak")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateGiroList
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "History"
    },
    model: {
      value: (_vm.isModalHistory),
      callback: function($$v) {
        _vm.isModalHistory = $$v
      },
      expression: "isModalHistory"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columnsHistory,
      "data": _vm.dataHistory
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.isModalEdit),
      callback: function($$v) {
        _vm.isModalEdit = $$v
      },
      expression: "isModalEdit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2cb7f5",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Giro")])], 1), _vm._v(" "), _c('Form', {
    ref: "formEditGiro",
    attrs: {
      "model": _vm.formEditGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Form-item', [_c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupEdit),
      callback: function($$v) {
        _vm.isGroupEdit = $$v
      },
      expression: "isGroupEdit"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "17",
      "offset": "1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "move-up"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupEdit == false),
      expression: "isGroupEdit == false"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.formEditGiro.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "markingHeaderId", $$v)
      },
      expression: "formEditGiro.markingHeaderId"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-down"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupEdit == true),
      expression: "isGroupEdit == true"
    }],
    attrs: {
      "filterable": "",
      "placeholder": "Ketik Group Name",
      "remote-method": _vm.getGroupMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    model: {
      value: (_vm.formEditGiro.markingGroupId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "markingGroupId", $$v)
      },
      expression: "formEditGiro.markingGroupId"
    }
  }, _vm._l((_vm.optionGroupMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Terima Giro",
      "prop": "giroDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Terima Giro",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formEditGiro.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroDate", $$v)
      },
      expression: "formEditGiro.giroDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor Giro",
      "prop": "giroNumber"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEditGiro.giroId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroId", $$v)
      },
      expression: "formEditGiro.giroId"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Nomor Giro"
    },
    model: {
      value: (_vm.formEditGiro.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroNumber", $$v)
      },
      expression: "formEditGiro.giroNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nominal Giro",
      "prop": "giroNominal"
    }
  }, [_c('br'), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input",
    model: {
      value: (_vm.formEditGiro.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "giroNominal", $$v)
      },
      expression: "formEditGiro.giroNominal"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "paymentDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Jatuh Tempo",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formEditGiro.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "paymentDate", $$v)
      },
      expression: "formEditGiro.paymentDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": ""
    },
    model: {
      value: (_vm.formEditGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formEditGiro, "bankAccountId", $$v)
      },
      expression: "formEditGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEditdGiro
    },
    on: {
      "click": _vm.postUpdateGiro
    }
  }, [(!_vm.isLoadingEditdGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescription = ''
      }
    },
    model: {
      value: (_vm.isModalDelete),
      callback: function($$v) {
        _vm.isModalDelete = $$v
      },
      expression: "isModalDelete"
    }
  }, [_c('p', [_vm._v("Apakah anda yakin ingin menghapus pembayaran giro?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.formDeleteGiro.giroNumber))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteGiro.giroId),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteGiro, "giroId", $$v)
      },
      expression: "formDeleteGiro.giroId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteGiro.paymentId),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteGiro, "paymentId", $$v)
      },
      expression: "formDeleteGiro.paymentId"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.formDeleteGiro.giroNumber).toUpperCase() == _vm.confirmDescription.toUpperCase()),
      expression: "(formDeleteGiro.giroNumber).toUpperCase() == confirmDescription.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.deleteGiroPayment
    }
  }, [_vm._v("Hapus")])], 1)]), _vm._v(" "), _c('vue-html2pdf', {
    ref: "html2Pdf",
    attrs: {
      "show-layout": false,
      "float-layout": true,
      "enable-download": true,
      "preview-modal": false,
      "paginate-elements-by-height": 1400,
      "pdf-quality": 2,
      "manual-pagination": true,
      "html-to-pdf-options": this.htmlPdfOption,
      "pdf-content-width": "100%"
    }
  }, [_c('section', {
    attrs: {
      "slot": "pdf-content"
    },
    slot: "pdf-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking Group")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nomor Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nominal Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item bank-header"
  }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Mundur")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Kliring")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Keterangan Tgl. Mundu")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Keterangan Pembatalan")])]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, _vm._l((_vm.receivableGiroData), function(value, index) {
    return _c('section', {
      staticClass: "pdf-item"
    }, [_c('div', {
      staticClass: "table-row pdf-item",
      class: {
        'html2pdf__page-break page-break': (index + 1) % 12 === 0
      }
    }, [_c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.marking))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.markingGroup))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.paymentDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNumber))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNominal))]), _vm._v(" "), _c('div', {
      staticClass: "table-data bank-body"
    }, [_vm._v(_vm._s(value.accountName))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.dueDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.isClearing ? 'Ya' : 'Tidak'))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.dueNotes))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.cancelNotes))])]), _vm._v(" "), ((index + 1) % 12 === 0 && _vm.receivableGiroData.length !== index + 1) ? _c('div', {
      staticClass: "table-header"
    }, [_c('div', {
      staticClass: "header__item"
    }, [_vm._v("Marking")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Marking Group")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Nomor Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Nominal Giro")]), _vm._v(" "), _c('div', {
      staticClass: "header__item bank-header"
    }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Tgl. Mundur")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Kliring")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Keterangan Tgl. Mundu")]), _vm._v(" "), _c('div', {
      staticClass: "header__item"
    }, [_vm._v("Keterangan Pembatalan")])]) : _vm._e()])
  }), 0)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5f1a1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroCancelledHistory.vue
// module id = 1841
// module chunks = 1